import { Bookmark, ExplorerBookmarkState } from "@novorender/data-js-api";

export enum BookmarkAccess {
    Public,
    Personal,
}

/** The lightweight projection of one bookmark needed to render it in a list. */
export type BookmarkCatalogEntry = {
    id: string;
    name: string;
    description?: string;
    grouping?: string;
    img?: string;
};

/** A catalog entry together with the scope it was listed from. */
export type ScopedCatalogEntry = BookmarkCatalogEntry & { access: BookmarkAccess };

export type LegacyBookmark = Bookmark & { version?: undefined; explorerState: undefined };
export type V1Bookmark = Bookmark & { version?: undefined; explorerState: ExplorerBookmarkState };

export function isLegacyBookmark(bm: Bookmark): bm is LegacyBookmark {
    return !bm.explorerState;
}

/** The ids a bookmark shows through its default visibility, whichever way they were saved. */
export function shownIdsFromBookmark(objects: ExplorerBookmarkState["objects"]): number[] {
    return objects.shown?.ids ?? objects.highlightCollections.transparentSelectionBase?.ids ?? [];
}
